import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { PATH } from '@constants';
import { contextNamesSelector } from '@selectors';
import { useSelector, useTenantRole } from '@hooks';

import { OrganizationSettingsLayout } from '@components/Layouts';

import { withSuspense } from './utils';

const OrganizationUsersSettingsPage = lazy(
  () => import('@pages/OrganizationSettings/OrganizationUsersSettingsOutlet'),
);
const OrganizationGeneralSettingsPage = lazy(
  () => import('@pages/OrganizationSettings/OrganizationGeneralSettingsOutlet'),
);
const OrganizationSettingsReportsPage = lazy(
  () => import('@pages/OrganizationSettings/OrganizationSettingsReportsOutlet'),
);

export default function OrganizationSettingsRoutes() {
  const { organizationName } = useSelector(contextNamesSelector);
  const { isOrganizationManager, isInitialized } = useTenantRole();

  if (isInitialized && !organizationName) {
    return <Navigate replace to={PATH.HOME} />;
  }

  return (
    <Routes>
      <Route
        element={
          <OrganizationSettingsLayout isManager={isOrganizationManager} />
        }
      >
        <Route index element={withSuspense(OrganizationUsersSettingsPage)} />

        <Route
          path="users"
          element={withSuspense(OrganizationUsersSettingsPage)}
        />
        {isOrganizationManager && (
          <>
            <Route
              path="general"
              element={withSuspense(OrganizationGeneralSettingsPage)}
            />
            <Route
              path="reports"
              element={withSuspense(OrganizationSettingsReportsPage)}
            />
          </>
        )}
      </Route>
      <Route
        path="*"
        element={<Navigate replace to={PATH.ORGANIZATION_SETTINGS_USERS} />}
      />
    </Routes>
  );
}
